export interface IFooterItem {
  externalLink?: string
  text: string
  icon: string
  iconType: string
  to?: string
}

export class FooterItem {
  externalLink?: string
  text: string
  icon: string
  iconType: string
  to?: string
  constructor(from: IFooterItem) {
    this.externalLink = from.externalLink
    this.text = from.text
    this.icon = from.icon
    this.iconType = from.iconType
    this.to = from.to
  }
}
